module.exports = __webpack_public_path__ + "img/nav-timelines.7ef64a21.svg";